import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useStore } from '../../../store/index';
import { CompanyProfileHeader } from '../../../components/JobPostings/CompanyProfilePage/CompanyProfileHeader';
import { CompanyProfileDetails } from '../../../components/JobPostings/CompanyProfilePage/CompanyProfileDetails';
import { CompanyProfileTips } from '../../../components/JobPostings/CompanyProfilePage/CompanyProfileTips';
import { CompanyProfileButtons } from '../../../components/JobPostings/CompanyProfilePage/CompanyProfileButtons';
import { Spinner } from '../../../components/common/Spinner/Spinner';
import JobPostingNotification from '../JobPostingPage/JobPostingDetails/JobPostingNotification';

const _CompanyProfilePage = () => {

  const {
    companyProfileStore: {
      companyProfile,
      setCompanyProfile,
      getCompanyProfile,
      isLoading,
      submitErrorNotification
    }
  } = useStore();

  const [profile, setProfile] = useState({
    url: '',
    description: ''
  });

  useEffect(() => {
    getCompanyProfile();
  }, []);

  useEffect(() => {
    setProfile(companyProfile);
  }, [companyProfile]);

  const updateCompanyProfile = () => {
    setCompanyProfile(profile);
  };

  if (isLoading) {
    return (
      <Spinner />
    );
  }

  return (
    <div>
      <ErrorBoundary name="company-profile-header">
        <CompanyProfileHeader />
      </ErrorBoundary>
      <Row>
        <Col xs={9} md={10}>
          <ErrorBoundary name="company-profile-details">
            <CompanyProfileDetails
              profile={profile}
              setProfile={setProfile}
            />
          </ErrorBoundary>
          <ErrorBoundary name="company-profile-buttons">
            <CompanyProfileButtons
              update={updateCompanyProfile}
              profile={profile}
            />
          </ErrorBoundary>
        </Col>
        <Col xs={3} md={2}>
          <ErrorBoundary name="company-profile-tips">
            <CompanyProfileTips />
          </ErrorBoundary>
        </Col>
      </Row>
      <ErrorBoundary name="job-posting-notification">
        <JobPostingNotification
          visible={submitErrorNotification}
          title="Error"
          text="Please provide a valid Company URL."
          color="red"
        />
      </ErrorBoundary>
    </div>
  );
};

export const CompanyProfilePage = observer(_CompanyProfilePage);
